import { commonFormControlErrorStateMatcher, commonFormControlSuccessStateMatcher } from "./state-matchers";

window.commonFormControlErrorStateMatcher = commonFormControlErrorStateMatcher;
window.commonFormControlSuccessStateMatcher = commonFormControlSuccessStateMatcher;
